import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Line } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { makeStyles, Typography } from '@material-ui/core';

import Tab from 'src/components/tab';
import ChartLegend from 'src/components/chartLegend';
import ChartWrapper from 'src/components/chartWrapper';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from 'src/components/table';

import { coloredDatasets } from 'src/helpers/chartJsHelpers';

import { setTabExpend } from './slice';

const data = coloredDatasets('line', {
  labels: ['Monday', 'Tuesday', ' Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  datasets: [
    {
      label: 'Last 7 days',
      data: [12, 8, 3, 5, 3, 3, 2],
      fill: false,
    },
    {
      label: 'Next 7 days',
      data: [12, 19, 3, 25, 3, 5, 2],
      fill: false,
    },
  ],
});

const options = {
  maintainAspectRatio: false,
  cornerRadius: 10,
  fullCornerRadius: false,
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          padding: 20,
        },
        gridLines: {
          drawTicks: false,
          drawBorder: false,
        },
      },
    ],
    xAxes: [
      {
        offset: true,
        ticks: {
          // beginAtZero: true,
          padding: 20,
        },
        gridLines: {
          // display: false,
          borderDash: [8, 4],
          drawTicks: false,
        },
      },
    ],
  },
  legend: {
    display: false,
  },
  tooltips: {
    callbacks: {
      labelColor: (tooltipItem, chart) => {
        const dataset = chart.config.data.datasets[tooltipItem.datasetIndex];
        return {
          backgroundColor: dataset.borderColor,
        };
      },
    },
  },
};

const legend = ['Last 7 Days', 'Next 7 Days'];

const useStyles = makeStyles(theme => ({
  tableContainer: {},
  table: {
    width: 780,
    margin: 'auto',
  },
}));

const UpcomingCalls = props => {
  const { isTabExpended } = props;
  const classes = useStyles();

  const prismicContent = useStaticQuery(graphql`
    query {
      allPrismicOverview {
        edges {
          node {
            data {
              title6 {
                html
                text
                raw
              }
              titleTooltip6 {
                html
                text
                raw
              }
            }
          }
        }
      }
    }
  `);

  const prismicData = prismicContent.allPrismicOverview.edges[0].node.data;

  const handelExpand = () => {
    props.setTabExpend(!isTabExpended);
  };

  return (
    <Tab
      title={prismicData.title6.text}
      tooltipedText={prismicData.titleTooltip6.text}
      drag
      onClick={handelExpand}
      expanded={isTabExpended}
    >
      <ChartLegend legend={legend} maxWidth={300} />
      <ChartWrapper>
        <Line options={options} data={data} height={300} />
      </ChartWrapper>
      <TableContainer className={classes.tableContainer}>
        <Table aria-label="simple table" className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>New Leads</TableCell>
              <TableCell>Reattempts</TableCell>
              <TableCell>After Hour Leads</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">
                <Typography variant="body2" align="right">
                  Last 7 Days
                </Typography>
              </TableCell>
              <TableCell>150</TableCell>
              <TableCell>52</TableCell>
              <TableCell>48</TableCell>
              <TableCell>250</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                <Typography variant="body2" align="right">
                  Next 7 Days
                </Typography>
              </TableCell>
              <TableCell>150</TableCell>
              <TableCell>52</TableCell>
              <TableCell>48</TableCell>
              <TableCell>250</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Tab>
  );
};

const mapStateToProps = ({ me }) => {
  const { overview } = me;
  const { upcomingCalls } = overview;
  return { ...upcomingCalls };
};

const mapDispatchToProps = { setTabExpend };

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(UpcomingCalls));
